<template>
	<div class="posbox wid100" :class="{disamask: disabled}" v-show="show">  
		<template v-if="islook">
			<div class="btnlist " v-if="btnshow">
				<div class="head_btn" @click="craete_pro">
					新建产品
				</div>
				<div class="head_btn" @click="fn_pro_show">
					添加产品
				</div>
			</div>
			<div class="pro_list" v-show="pro_list.length">
				<div class="pro_item" v-for="(item, index) in pro_list">
					<div class="img_box">
						<img :src="item.image" alt="">
					</div>
					<div class="pro_info">
						<div class="pro_name MultipleLines">
							{{item.name || ''}}
						</div>
						<div class="pro_bot">
							<div class="num">
								数量： {{item.num || ''}}
							</div>
							<div class="jiage">
								价格： <p>
									￥{{item.price || ''}}
								</p>
							</div>
						</div>
					</div>
					<div class="pro_post">
						<div @click="edit_spro(index)">
							<i class="el-icon-edit"></i>
						</div>
						<div @click="deleted_pro(index)">
							<i class="el-icon-delete"></i>
						</div>
					</div>


				</div>
			</div>
			<nodata :show="pro_list.length == 0" v-if="isnodata"></nodata>
		</template>
		<template v-else>
			<powershow :show="true"
			></powershow>
		</template>
		
		<!-- 添加产品  -->
		<Dialog :show.sync="pro_show" :name_width="pro_dialog" :appendtobody="true">
			<span slot="body">

				<div class="pro_top FlexRow">
					<el-dropdown @command="classhandleClick">
						<div class="pro_btn FlexRow">
							筛选
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item v-for="(item, index) in classdropdown">
								{{item.name || ''}}
							</el-dropdown-item>

						</el-dropdown-menu>
					</el-dropdown>


					<!--  -->
					<div class="searchinput">
						<el-input @keyup.enter.native="fn_getGoodlist" placeholder="请输入内容" v-model="shaixuan"
							class="search_input">
						</el-input>
						<div class="icons" @click="fn_getGoodlist">
							<i class="el-icon-search"></i>
						</div>
					</div>
					<!--  -->
				</div>

				<div class="pro_content">
					
					<div class="pro_item" v-for="(item, index) in selectpro">
						<div class="check_boxs FlexRow " @click="selectp_change(index)" v-show="!item.checked">
							<i class="el-icon-check"></i>
						</div>
						<div class="check_boxs FlexRow isActive" @click="selectp_change(index)" v-show="item.checked">
							<i class="el-icon-check"></i>
						</div>
						<div class="img_box" @click="selectp_change(index)">
							<el-image fit="cover" :src="item.image" lazy></el-image>
						</div>
						<div class="pro_info">
							<div class="pro_name">
								{{item.name || ''}}
							</div>
							<div class="pro_jiage FlexRow">
								价格：￥ 
								<el-input v-model="item.price" placeholder="请输入价格" style="wdith: 100px;"></el-input>
							</div>
						</div>
						<div class="add_bnt">
							<div class="add_bnts"  @click="addbtn(index, 1)">
								<i class="el-icon-minus"></i>
							</div>
							<input type="number" v-model="item.num" :min="1" :max="999" :maxlength="3">
							<div class="add_bnts" @click="addbtn(index, 2)">
								<i class="el-icon-plus"></i>
							</div>
						</div>
					</div>
				</div>


			</span>

			<div class="dialog-footer" slot="footer">
				<el-button class="b" @click="pro_show = false">取消</el-button>
				<el-button class="b save comkl" @click="pro_comkl">确定</el-button>
			</div>
		</Dialog>
		<!--  -->

		<!-- 新建 编辑 产品  -->
		<Dialog :show.sync="eidht_show" :name_width="eidht_dialog" :appendtobody="true">
			<span slot="body">

				<el-form ref="form"  label-width="120px">
					<el-form-item label="产品图片：">
						<div class="add_imgbox" v-show="create_obj.image">
							<img width="100%" :src="create_obj.image" alt="">
							<div class="add_mask FlexRow">
								<div @click="clearFiles">
									<i class="el-icon-delete"></i>
								</div>

							</div>
						</div>

						<el-upload ref="uploadsimg" class="add_upload FlexRow" v-show="create_obj.image == ''"
							action="https://scrmdata.51kuaiding.com/hkt_material/material/upload_file"
							accept=".jpg,.jpeg,.png,.JPG,.JPEG" :auto-upload="false" :show-file-list="false" :limit="1"
							:on-change="imageChange">
							<i class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>



					</el-form-item>
					<el-form-item label="产品名称：">

						<el-input placeholder="请输入内容" v-model="create_obj.name">
						</el-input>
					</el-form-item>
					<el-form-item label="产品价格：">
						<el-input type="number" placeholder="请输入内容" v-model="create_obj.price">
						</el-input>
					</el-form-item>
					<el-form-item label="产品数量：">

						<el-input type="number" placeholder="请输入内容" v-model="create_obj.num">
						</el-input>
					</el-form-item>
				</el-form>

			</span>

			<div class="dialog-footer" slot="footer">
				<el-button class="b" @click="eidht_show = false">取消</el-button>
				<el-button class="b save comkl" @click="eidht_comkl">确定</el-button>
			</div>
		</Dialog>
		<!--  -->
		
		
		
		
		<el-dialog
		  title="提示"
		  :visible.sync="qd_show"
		  width="300px"
		  :modal="false"
		  :append-to-body="true"
		  >
		  <span>您确定删除吗？</span>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="qd_show = false">取 消</el-button>
		    <el-button class="comkl" @click="qd_comkl">确 定</el-button>
		  </span>
		</el-dialog>
		<!--  -->

	</div>
</template>

<script>
	var that
	import Dialog from "components/content/dialog/Dialog";
	import nodata from "@/components/content/publics/nodata.vue";
	import powershow from "@/components/content/publics/powershow.vue";
	
	import {
		getGoodlist,

		setupfile,
	} from 'network/hk_operset'
	import {
		retujudpower,
		retupower,
		alertMess,
		retfieldPower,
		fn_fielddisabled,
	} from '@src/network/kh_public'
	
	
	export default {
		name: "addproduct",
		components: {
			Dialog,
			nodata,
			powershow,
		},

		props: {
			 
			islook:{
				type: Boolean,
				default: true,
			},
			isedit:{
				type: Boolean,
				default: true,
			},
			
			ispowerEdit:{
				type: Boolean,
				default: true,
			},
			ispowerDel:{
				type: Boolean,
				default: true,
			},
			isnodata:{
				type: Boolean,
				default: true,
			},
			show:{
				type: Boolean,
				default: false,
			},
			disabled:{
				type: Boolean,
				default: false,
			},
			// 
			fieldid: {
				type: Number,
				default: 0,
			},
			pro_list: {
				type: Array,
				default:  ()=>{
					return []
				},
			},
			btnshow:{
				type: Boolean,
				default: true,
			},
		},
		data() {
			return {
				page_power: {
					show: false,
					edit: false,
				},
				curfield_power: '',
				
				eidht_show: false,
				is_eidht: false,
				qd_show: false,
				qd_dialog: {
					name: '提示',
					width: '300px'
				},
				eidht_dialog: {
					name: '新建产品',
					width: '500px'
				},
				create_obj: {
					image: '',
					name: '',
					price: '',
					num: '',
				},
				//
				pro_show: false,
				pro_dialog: {
					name: '添加产品',
					width: '500px'
				},

				Currentclass: '',
				selectpro: [],

				urlhead: 'https://scrm.51kuaiding.com/scrm/hktxcx/customer',

				classdropdown: [],

				shaixuan: '',

				current_edit: '',
				currentDel: '',
			}
		},

		created() {
			that = this
			
		},
		watch: {
			show(){
				if(this.show) {
					
					
				}
			},
		},
		methods: {
			
			fn_pro_show(){
				if(retujudpower(this.ispowerEdit && this.isedit)) {
					// 获取产品列表
					this.fn_getGoodlist()
					this.pro_show = true
				}
				
			},

			// 新建产品
			craete_pro() {
				if(retujudpower(this.ispowerEdit && this.isedit)) {
					this.eidht_show = true
					this.is_eidht = false
					this.eidht_dialog.name = '新建产品'
					this.create_obj = {
						image: '',
						name: '',
						price: '',
						num: '',
					};
				}
			},
			//
			addbtn(index, flag){
				let num = this.selectpro[index].num * 1
				if(flag == 1) {
					if(num > 1) {
						this.selectpro[index].num = (this.selectpro[index].num * 1) - 1
					}
				}
				else {
					if(num < 999) {
						this.selectpro[index].num = (this.selectpro[index].num * 1) + 1
					}
				}
			},
			deleted_pro(index) {
				console.log(this.ispowerDel,'ispowerDel')
				if(retujudpower(this.ispowerDel && this.isedit)) {
					this.qd_show = true
					this.currentDel = index
				}
				
			},
			qd_comkl(){
				this.qd_show = false
				this.$emit('deleteds', this.currentDel)
			},
			closetpop() {
				this.pro_show = false
				this.eidht_show = false
				this.create_obj = {
					image: '',
					name: '',
					price: '',
					num: '',
				};
				this.clearFiles()
			},
			classhandleClick(index) {
				this.Currentclass = this.classdropdown[index]
				this.fn_getGoodlist()
			},

			selectp_change(index) {
				let obj = this.selectpro[index]
				obj.checked = !obj.checked
			},
			// 获取产品列表
			fn_getGoodlist() {
				let class_id = ''
				if (this.Currentclass) {
					class_id = this.Currentclass
				}
				let search = ''
				if(this.shaixuan) {
					search = this.shaixuan.trim()
				}
				getGoodlist(search, class_id).then(res => {
					if (this.handlereq(res)) {
						let obj = res.result
						this.classdropdown = obj.goods_class
						let list = obj.goods.data
						for (let item of list) {
							item.num = 1
							item.checked = false
						}

						this.selectpro = list
						
					}
				})
			},


			// 编辑产品
			edit_spro(index) {
				if(retujudpower(this.ispowerEdit && this.isedit)) {
					let obj = this.pro_list[index]
					this.current_edit = index
					this.create_obj = JSON.parse(JSON.stringify(obj))
					this.is_eidht = true
					this.eidht_show = true
					this.eidht_dialog.name = '编辑产品'
					if (this.$refs.uploadsimg) {
						this.$refs.uploadsimg.clearFiles()
					}
				}
			},
			clearFiles() {
				this.create_obj.image = ''
				if (this.$refs.uploadsimg) {
					this.$refs.uploadsimg.clearFiles()
				}
			},

			eidht_comkl() {
				if (this.create_obj.name == '') {
					this.alertMess('请输入产品名称', 'error')
				} else if (this.create_obj.price == '') {
					this.alertMess('请输入产品价格', 'error')
				} else if (this.create_obj.num == '') {
					this.alertMess('请输入产品数量', 'error')
				} else {
					if (!this.create_obj.image) {
						this.create_obj.image = this.urlhead + '/nonrpro.png'
					}

					if (this.is_eidht) {
						this.$emit('eidht', {create_obj: this.create_obj, current_edit: this.current_edit})

					} else {
						this.$emit('pushpro', {create_obj: this.create_obj})
					}
					this.closetpop()
				}
			},
			
			// 添加产品确定
			pro_comkl() {
				
				
				let arr = this.selectpro.filter(v => v.checked) // 5 
				
				if (arr.length > 0) {
					
					let conts = 20 - this.pro_list.length  //20 - 16 1
					if (conts < arr.length) {
						arr = arr.slice(0, conts)
						this.alertMess('最多选择20个产品', 'error')
					}
					let newArr = []
					for (let item of arr) {
						let ele = {
							image: item.image, 
							name: item.name, 
							num: item.num,
							price: item.price,
						}
						newArr.push(ele)
					}
					this.$emit('procomkl', {newArr: newArr})
					this.closetpop()
				}
				else {
					this.alertMess('请选择产品', 'error')
				}
				
				
			},


			fn_setupfile(file) {
				let fd = new FormData()
				fd.append('store_id', that.$store.state.store_id)
				fd.append('file_name', file.name)
				fd.append('file[]', file.raw)
				setupfile(fd).then(res => {
					let obj = res.result[0] // 返回的文件信息
					// 
					if (this.handlereq(res)) {

						this.create_obj.image = obj.file_url

					}

				})
			},


			// 上传图片
			imageChange(file, fileList) {
				console.log(file, fileList, 'fileList')

				
				if (file.size / 1024 / 1024 < 20) {
					if (file.raw.type != 'video/mp4') {
						this.fn_setupfile(file)
					}
				} else {
					this.$message({
						message: '上传图片大小不能超过20MB！',
						type: 'error',
						offset: 100
					});
				}



			},







			// 弹出提示
			alertMess(message, type) {
				this.$message({
					showClose: true,
					offset: 100,
					duration: 2000,
					message,
					type: type ? type : 'success',
				});
			},
			handlereq(res) {
				if (res) {
					if (res.code === 10000) { // 请求成功
						return true
					} else { // 请求发生错误
						this.alertMess(res.message, 'error')
						return false
					}
				}
			},


		}
	}
</script>

<style scoped lang="scss">
	
	.posbox{
		position: relative;
	}
	.posbox.disamask::after{
		top: 0;
		left:0;
		content: '';
		display:block;
		position: absolute;
		z-index: 100;
		width: 100%;
		height: 100%;
		cursor: not-allowed;
	}
	
	.comkl{
		background-color: #2a75ea !important;
		color:#fff !important;
	}
	
	.add_upload {
		width: 79px;
		height: 79px;
		border: solid 1px #Eee;
		
	}
	
	/deep/ .add_upload .el-upload {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	/deep/ .el-form-item{
		display:flex;
		margin-bottom: 20px;
	}
	
	.add_imgbox:hover .add_mask {
		background-color: rgba(0, 0, 0, 0.5);
		
	}
	
	.add_imgbox:hover .add_mask i {
		opacity: 1;
	}
	.add_imgbox {
		width: 79px;
		height: 79px;
		border: solid 1px #eee;
		border-radius: 5px;
		overflow: hidden;
		position: relative;
	
		.add_mask {
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			z-index: 3;
			position: absolute;
			justify-content: space-around;
			transition: all .3s;
	
			div {
				cursor: pointer;
	
				i {
					color: #fff;
					opacity: 0;
					font-size: 15px;
				}
			}
		}
	
		img {
			width: 79px;
			height: 79px;
			display: block;
	
		}
	}
	
	/deep/ .head_btn .el-upload {
		color: #fff !important;
	}
	
	.pro_content {
		max-height: 500px;
		overflow: auto;
		width: 100%;
		padding: 20px 0;

		.pro_item {
			display: flex;
			align-items: center;
			width: 100%;
			padding: 10px 0;
			position: relative;
			.check_boxs.isActive{
				background: rgba(42, 117, 234, 1);
				border: none;
			}
			.check_boxs {
				border:solid 1px #ccc;
				margin-right: 21px;
				cursor: pointer;
				border-radius: 100%;
				width: 21px;
				height: 21px;
				overflow: hidden;
				background:#fff;
				
				i{
					font-size: 14px;
					color:#fff;
				}
			}

			.img_box {
				width: 67px;
				height: 67px;
				border-radius: 5px;
				overflow: hidden;
				border: solid 1px #Eee;
				.el-image{
					width: 100%;
					height: 100%;
				}
				img {
					width: 100%;
					height: 100%;
					display: block;
				}
			}

			.pro_info {
				padding-left: 20px;
				flex: 1;
				height: 67px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.pro_name {
					font-size: 14px;
					color: rgba(56, 56, 56, 1);
				}
				/deep/ .pro_jiage .el-input{
					width: 100px;
				}
				.pro_jiage {
					display: flex;
					align-items: center;
					justify-content: flex-start;
					
					color: rgba(128, 128, 128, 1);
					input{
						height: 30px;
						width: 100px;
						border: none !important;
						background: none !important;
						color: rgba(43, 117, 235, 1);
						font-size: 14px;
						box-shadow: none !important;
					}
					input:focus{
						border-color: transparent;
						border: none !important;
						background: none !important;
						box-shadow: none !important;
					}
				}
			}
			/deep/ .add_bnt .el-input{
				width: 130px;
			}
			.add_bnt {
				position: absolute;
				right: 10px;
				bottom: 10px;
				display:flex;
				align-items:center;
				justify-content: center;
				.add_bnts{
					width: 27px;
					height: 27px;
					display:flex;
					align-items:center;
					justify-content: center;
					cursor: pointer;
					border-radius: 3px;
					border: 1px solid rgba(229, 229, 229, 1); 
					i{
						color:rgba(204, 204, 204, 1);
						font-size: 15px;
					}
				}
				input{
					border: 1px solid rgba(229, 229, 229, 1); 
					width: 51px;
					height: 27px;
					border-radius: 3px;
					text-align:center;
					font-size: 16px;
					color: rgba(166, 166, 166, 1);
					margin: 5px;
					display:block;
				}
				.button {
					height: 100% !important;
				}
			}
		}
	}

	/deep/ .el-input-number span {
		display: block;
		height: 100% !important;
	}
	
	.searchinput{
		width: 100%;
		position: relative;
		display: flex;
		align-items: center;
		.icons{
			right: 20px;
			position: absolute;
			cursor: pointer;
			i{
				color:#ccc;
				font-size: 16px;
			}
		}
	}
	
	/deep/ .el-form-item__content {
		display: flex;
		width: auto !important;
		margin-left: 0 !important;
	}
	
	
	/deep/ .el-form .el-input {
		width: 330px !important;
	}
	/deep/ .el-form .el-input .el-input__inner {
		width: 330px !important;
	}
	
	.pro_top {
		width: 100%;
		margin-bottom: 10px;
		.pro_btn {
			cursor: pointer;
			width: 70px;
			height: 32px;
			border-radius: 2px;
			background: rgba(42, 117, 234, 1);
			font-size: 14px;

			color: rgba(255, 255, 255, 1);
		}

		.search_input {
			flex: 1;
			margin-left: 10px;
			max-width: 368px;
		}
	}

	.btnlist {
		display:flex;
		align-items:center;
		justify-content: flex-start;
		margin-bottom: 20px;

		.head_btn {
			width: 85px;
			height: 32px;
			border-radius: 2px;
			font-size: 14px;
			font-weight: 500;
			color: rgba(255, 255, 255, 1);
			display: flex;
			align-items: center;
			justify-content: center;
			background: rgba(42, 117, 234, 1);
			margin-right: 5px;
			cursor: pointer;

			.btn_upload {
				width: 100%;
				height: 100%;
				font-size: 14px;
				font-weight: 500;
				color: rgba(255, 255, 255, 1);

			}
		}
	}

	.pro_list {
		width: 100%;
	
		display: flex;
		flex-wrap: wrap;

		.pro_item {
			margin-right: 20px;
			margin-bottom: 20px;
			width: 333px;
			height: 110px;
			padding: 10px;
			border: 1px solid rgba(220, 223, 230, 1);
			display: flex;
			align-items: center;
			position: relative;
			line-height: 30px;

		}

		.pro_item .img_box {
			width: 92px;
			height: 92px;
			overflow: hidden;
			border-radius: 4px;
			border:solid 1px #eee;
		}

		.pro_item .img_box img {
			width: 100%;
			height: 100%;
		}

		.pro_item .pro_info {
			flex: 1;
			height: 100%;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			// padding: 10px 0;
			padding-left: 15px;

		}

		.pro_name {
			font-size: 14px;
			font-weight: 400;
			color: rgba(56, 56, 56, 1);
			line-height: 20px;
		}

		.pro_bot .num {
			font-size: 12px;
			color: rgba(128, 128, 128, 1);
			line-height: 10px;
		}

		.pro_bot .jiage {
			margin-top: 8px;
			font-size: 12px;
			line-height: 10px;
			display: flex;
			align-items: center;
			color: rgba(128, 128, 128, 1);

		}

		.pro_bot .jiage p {
			color: rgba(43, 117, 235, 1);
		}

	}

	.pro_post {
		display: flex;
		align-items: center;
		position: absolute;
		bottom: 0px;
		right: 20px;

		div {
			margin-left: 15px;

			i {
				font-size: 16px;
				cursor: pointer;
				color: rgba(145, 148, 154, 1);
			
			}
			i:hover{
				color:#2a75ea;
			}
		}

	}
</style>
